export default function Notice({ kind = 'info', children }: { kind?: 'info' | 'error' | 'success'; children: React.ReactNode }) {
  const cls = kind === 'error' ? 'bg-danger/10 text-danger border-danger/30'
    : kind === 'success' ? 'bg-ball-500/10 text-ball-300 border-ball-500/30'
    : 'bg-court-500/10 text-court-400 border-court-500/30';
  return <div className={`rounded-xl border px-3 py-2.5 text-sm ${cls}`}>{children}</div>;
}
